import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Form, Grid } from "tabler-react";

import { AlertComponent, LoadingButton } from "../../../component";

import { userActions } from "../../../store/actions/userActions";
import { alertActions } from "../../../store/actions/alertActions";

class ChangePasswordPage extends Component {
  constructor() {
    super();
    this.state = {
      old_pwd: "",
      new_pwd: "",
      c_pwd: "",
      errors: null,
    };
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      history: this.props.history,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let validationCheck = this.handleValidation();
    if (
      validationCheck.old_pwd === "" &&
      validationCheck.new_pwd === "" &&
      validationCheck.c_pwd === ""
    ) {
      this.props.updatePassword(this.state);
    }
  };

  handleValidation = (e) => {
    let values = this.state;
    // same as above, but feel free to move this into a class method now.
    let errors = {
      old_pwd: "",
      new_pwd: "",
      c_pwd: "",
    };
    if (!values.old_pwd) {
      errors.old_pwd = "This field is required";
    }
    if (values.old_pwd === values.new_pwd) {
      errors.old_pwd = "Current and old password should not be same";
    }
    if (!values.new_pwd) {
      errors.new_pwd = "This field is required";
    }
    if (!values.c_pwd) {
      errors.c_pwd = "This field is required";
    }
    if (values.c_pwd !== values.new_pwd) {
      errors.c_pwd = "Password don't match";
    }
    this.setState({
      errors: errors,
    });
    return errors;
  };
  componentDidMount() {
    this.props.clearAlerts();
  }
  render() {
    let alertComponent;
    const { alert, isPwdChanged } = this.props;
    const { old_pwd, new_pwd, c_pwd, errors } = this.state;
    // const errors = this.state.error;
    if (alert !== {}) {
      alertComponent = alert.message && alert.type && (
        <AlertComponent alert={alert} auth={false} />
      );
    }
    return (
      <Form className="card" onSubmit={this.handleSubmit}>
        <Card.Body>
          <Card.Title>Change Password</Card.Title>
          <Grid.Row>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              {alertComponent ? alertComponent : null}
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <Form.Label>Old Password</Form.Label>
                <Form.Input
                  type="password"
                  name="old_pwd"
                  className="mb-2 "
                  error={errors && errors.old_pwd}
                  onChange={this.handleChange}
                  value={old_pwd}
                />
              </Form.Group>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <Form.Label>New Password</Form.Label>
                <Form.Input
                  type="password"
                  name="new_pwd"
                  className="mb-2 "
                  error={errors && errors.new_pwd}
                  onChange={this.handleChange}
                  value={new_pwd}
                />
              </Form.Group>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={12} className="mb-2 ">
              <Form.Group className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Input
                  type="password"
                  className="mb-2 "
                  name="c_pwd"
                  error={errors && errors.c_pwd}
                  onChange={this.handleChange}
                  value={c_pwd}
                />
              </Form.Group>
            </Grid.Col>
          </Grid.Row>
        </Card.Body>
        <Card.Footer className="text-right">
          <LoadingButton
            loadingState={isPwdChanged}
            preloadingText="Change Password"
            loadingText="Changing Password"
          />
        </Card.Footer>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { isPwdChanged } = state.user;
  return {
    alert,
    isPwdChanged,
  };
}

const mapDispatchToProps = {
  updatePassword: userActions.updatePassword,
  errorAlerts: alertActions.error,
  successAlerts: alertActions.success,
  clearAlerts: alertActions.clear,
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage);
